import { Form } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/legalAssistant/common'
import { SelectOneDrivePicker } from '~/features/formConfiguration/client/components/CustomInputs/SelectOneDrivePicker'
import { TitlePrimary } from '~/features/shared/components'
import { Extensions } from '~/plugins/data-connector/providers/oneDrive/common'
import { StepProps } from '../types'

type Props = StepProps

export const StepOneDrive: React.FC<Props> = ({ ...props }) => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>
          Choose the files you'd like to share with me
        </TitlePrimary>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {options => {
            const providerAccountId = options.getFieldValue([
              'fileServices',
              'accountOneDrive',
            ])

            if (!providerAccountId) {
              return <></>
            }

            return (
              <Form.Item
                name={['oneDriveSettings', 'files']}
                label="Legal documents"
              >
                <SelectOneDrivePicker
                  providerAccountId={providerAccountId}
                  isMultiple={true}
                  buttonEmptyPlaceholder="Choose files"
                  extensions={[
                    Extensions.DOC,
                    Extensions.DOCX,
                    Extensions.XLS,
                    Extensions.XLSX,
                    Extensions.CSV,
                    Extensions.PDF,
                    Extensions.MSG,
                  ]}
                />
              </Form.Item>
            )
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
